// extracted by mini-css-extract-plugin
export default {"BasicLayout":"BasicLayout_BasicLayout__ydmf3","children":"BasicLayout_children__-PgX1"};